module.exports = __webpack_public_path__ + "media/images/ohap_thumbnail enlarge-654d8c42dd392e0d69aac5ef6eaad32a.png";